enum TimerTypes {
  Absolute = 'absolute',
  Relative = 'relative',
};

export default TimerTypes;